import propTypes from 'prop-types';
import React from 'react';
import * as theme from '../constants/theme';

const {TITLE} = theme;

const Logo = ({margin, width, ...props}) => (
	<div {...props} style={{margin, maxWidth: width}}>
		<img
			src='/static/logo.png'
			alt={TITLE}
		/>
		<style jsx>
			{`
				div {
					display: inline-block;
				}
			`}
		</style>
	</div>
);

Logo.propTypes = {
	margin: propTypes.string,
	width: propTypes.string
};

export default Logo;



// WEBPACK FOOTER //
// components/logo.js